import { withInstall } from '@klondpay/utils';
import discountDetail from './src/index.vue';
export const DiscountDetail = withInstall(discountDetail);
export default DiscountDetail;
